import { useEffect } from 'react';
import {
  generatePath,
  Outlet,
  useNavigate,
  useOutletContext,
} from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { useAppSelector, useAppDispatch } from '@store';
import ExportBanksColumn from '../../components/export-column/column-banks';
import { useLazyGetExportPspPartnersQuery } from './store/services';
import { clearAccounts } from './store/slices/accounts';

import ROUTES from '../../routes';

import cn from './styles.module.css';

const ExportBanks = (): React.JSX.Element => {
  const navigate = useNavigate();
  const { banks } = useAppSelector((state) => state.export.banks);

  const { sendMessage } = useOutletContext<{ sendMessage: SendMessage }>();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (banks.length) {
      navigate(generatePath(ROUTES.EXPORT_BANKS, { bankId: banks[0].id }), {
        replace: true,
      });
    }
  }, [banks]);

  const [getBanksList, { isFetching, isLoading }] =
    useLazyGetExportPspPartnersQuery();

  useEffect(() => {
    getBanksList('');
  }, [getBanksList]);

  return (
    <>
      <div className={cn.columnWrapper}>
        <ExportBanksColumn
          banks={banks}
          isLoading={isLoading || isFetching}
          onClearAccountState={() => dispatch(clearAccounts())}
        />
      </div>
      <Outlet context={{ sendMessage }} />
    </>
  );
};

export default ExportBanks;
